import React from 'react';
import './MatchQuestion.scss';

const MatchQuestion = (props) => {
    return (
        <div className={`match-question ${props.wrong ? 'answer-wrong' : ''} ${props.correct ? 'answer-correct' : ''}`}>
            <div>
                <div>
                    <h6>Meaning</h6>
                    <p style={{ color: props.specs?.leftColor }}>{props.specs?.meaningLeft}</p>
                </div>
            </div>
            <div>
                <div>
                    <h6>Color</h6>
                    <p style={{ color: props.specs?.rightColor }}>{props.specs?.meaningRight}</p>
                </div>
            </div>
        </div>
    );
}

export default MatchQuestion;